import { render, staticRenderFns } from "./ProjectsModule.vue?vue&type=template&id=1ecd6f6e&scoped=true"
import script from "./ProjectsModule.vue?vue&type=script&lang=js"
export * from "./ProjectsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd6f6e",
  null
  
)

export default component.exports